module.exports = __webpack_public_path__ + "img/unknown.fe37fb05.svg";